import { useSelector } from 'react-redux'

import * as FilterSelectors from 'modules/filter/selectors'
import { ITimePeriod } from 'modules/filter/types'

/***
 * Hook to pull out time period from redux
 *
 * @returns {ITimePeriod}
 */

const useTimePeriod = (): ITimePeriod =>
  useSelector((state: any) => FilterSelectors.timePeriod(state))

export default useTimePeriod
